<template>
  <div class="global-modals">
    <!-- Global modals -->
    <UEConfirmModal />
    <UEOkModal />

    <!-- Admin section modals -->
    <AdminSendRequestModal />
    <AssociateCompanyModal />
    <CsvImportModal />
    <NewCompanyModal />

    <!-- App modals -->
    <AssetFilterModal />
    <CreateSurveySummaryModal />
  </div>
</template>

<script lang="ts">
// Global modals
import CsvImportModal from '@/app/components/modals/CsvImportModal.vue'
import UEConfirmModal from '@/app/components/modals/UEConfirmModal.vue'
import UEOkModal from '@/app/components/modals/UEOkModal.vue'

// Admin section modals
import AdminSendRequestModal from '@/admin/components/modals/SendRequestModal.vue'
import AssociateCompanyModal from '@/admin/components/modals/AssociateCompanyModal.vue'
import NewCompanyModal from '@/admin/components/modals/NewCompanyModal.vue'

// App modals
import AssetFilterModal from '@app/components/modals/AssetFilterModal.vue'
import CreateSurveySummaryModal from '@app/components/modals/CreateSurveySummaryModal.vue'
/**
 * GlobalModals component
 *
 * This component includes all global modals that should be accessible from anywhere in the app.
 * The modals themselves will use UEModal which is connected to the ModalStore for state management.
 *
 * To open a modal from anywhere in the app, use:
 *
 * import { useModalStore } from '@/stores/ModalStore'
 *
 * // In your component or page
 * const modalStore = useModalStore()
 * modalStore.open('modal_name', { param1: value1, param2: value2 })
 *
 * to close the modal:
 * modalStore.close('modal_name')
 */
export default {
  name: 'GlobalModals',
  components: {
    AdminSendRequestModal,
    AssetFilterModal,
    AssociateCompanyModal,
    CreateSurveySummaryModal,
    CsvImportModal,
    NewCompanyModal,
    UEConfirmModal,
    UEOkModal,
  },
}
</script>
